<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn v-if="!isUploading" class="float-right" v-on:click="isUploading = true" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Upload
                            to Gallery</v-btn>
                        <v-btn v-if="isUploading" class="float-right" v-on:click="isUploading = false" :color="($vuetify.theme.dark) ? 'darkPrimeBack' : 'lightPrimeBack'">Back to
                            Gallery</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
            <v-col v-if="isUploading">
                <UploadImage @snack="snackmain" title="Upload to Gallery"></UploadImage>
            </v-col>
            <v-col v-if="!isUploading">
                <S3Gallery @snack="snackmain"></S3Gallery>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UploadImage from "../components/UploadImage.vue";
import S3Gallery from "../components/S3Gallery.vue";
import accessHelper from "@/mixins/accessHelper";

export default {
    name: "GalleryPage",
    setup() {

    },
    props: {

    },
    mixins: [accessHelper],
    components: {
        UploadImage,
        S3Gallery
    },
    data: () => ({
        isUploading: false,
    }),
    mounted: function () {
    },
    watch: {

    },
    methods: {
        snackmain: function (message) {
            this.$emit('snack', message);
        },
        uploadingScreen: function () {
            this.isUploading = true;
        }
    },
}
</script>

<style scoped>
</style>